<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&hellip;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Catálogos</h1>
          <p class="view-header__subtitle">Gestioná los catálogos de productos publicados.</p>
        </div>
        <div class="view-header__actions">
          <router-link to="/ecom/catalogos/nuevo/" class="btn view-header__btn view-header__btn--primary">
            <i class="bi bi-plus-lg"></i>
            Nuevo catálogo
          </router-link>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="filters.q" type="search" class="form-control" placeholder="Buscar...">
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <div class="table-responsive">
        <table class="table mb-0">
          <thead>
            <tr role="row">
              <th>Fecha</th>
              <th>Nombre</th>
              <th>Código</th>
              <th class="text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="catalogs.length < 1">
              <td colspan="4" class="data-table__empty">No hay catálogos disponibles</td>
            </tr>
            <tr v-for="catalog in catalogs" :key="catalog.id" role="row">
              <td>{{ catalog.created_at }}</td>
              <td><span class="data-table__primary">{{ catalog.name }}</span></td>
              <td>
                <a :href="catalog.link" target="_blank" class="data-table__primary">{{ catalog.uid }}</a>
              </td>
              <td class="text-right">
                <div class="table-action-group">
                  <button type="button" class="table-action-btn" title="Copiar URL" @click="copyUrl(catalog.link)">
                    <i class="bi bi-files"></i>
                  </button>
                  <button type="button" class="table-action-btn" title="Descargar PDF" @click="getPDF(catalog.id)">
                    <i class="bi bi-filetype-pdf"></i>
                  </button>
                  <router-link :to="'/ecom/catalogos/editar-catalogo/' + catalog.id" class="table-action-btn" title="Editar">
                    <i class="bi bi-pencil-square"></i>
                  </router-link>
                  <button type="button" class="table-action-btn" title="Eliminar" @click="deleteCatalog(catalog)">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PAGINACION -->
      <div class="data-table__footer">
        <div class="data-table__info">
          Página {{ filters.page }} de {{ totalPages || 1 }}
        </div>
        <ul class="data-table__pagination">
          <li class="page-item" :class="{ 'disabled': filters.page == 1 }">
            <a class="page-link" href="#" @click.prevent="prevPage()">Anterior</a>
          </li>
          <li v-if="(filters.page - (pageInterval / 2)) > 0" class="page-item">
            <a class="page-link" href="#" @click.prevent="prevPage()">...</a>
          </li>
          <template v-for="index in totalPages">
            <li
              v-if="inIntervalPage(index)"
              :key="index"
              class="page-item"
              :class="{ 'active': filters.page == index }"
            >
              <a class="page-link" href="#" @click.prevent="changePage(index)">{{ index }}</a>
            </li>
          </template>
          <li v-if="totalPages > (filters.page + (pageInterval / 2))" class="page-item">
            <a class="page-link" href="#" @click.prevent="nextPage()">...</a>
          </li>
          <li class="page-item" :class="{ 'disabled': filters.page >= totalPages }">
            <a class="page-link" href="#" @click.prevent="nextPage()">Siguiente</a>
          </li>
        </ul>
        <div class="data-table__page-size">
          <label class="mb-0">Mostrar</label>
          <q-select
            v-model="filters.itemsPerPage"
            :options="[{ value: 15, label: '15' }, { value: 25, label: '25' }, { value: 50, label: '50' }]"
          />
          <span>registros</span>
        </div>
      </div>
    </div>

    <router-view v-if="isEditViewActive"></router-view>
  </div>
</template>
<script>
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: { QSelect },
  data() {
    return {
        isEditViewActive: false,
        loading:false,
        catalogs:[],
        filters:{
            q:'',
            itemsPerPage:15,
            page:1,
        },
        totalPages:0,
        pageInterval:22,
        catalogToEdit:null,
    }
  },
  mounted() {
      this.getCatalogs();
  },
  methods: {
    toggleEditCatalog() {
        this.isEditViewActive = !this.isEditViewActive
    },
    getCatalogs(){
        let vm = this;
        vm.loading=true;
        this.$http.post("/api/catalogs/getList", this.filters)
        .then((response) => {
            if (response.data.success) {
                vm.catalogs = response.data.data.list;
                vm.totalPages=response.data.data.totalPages;
                vm.loading=false;
            } else {
                vm.loading=false;
                
            }
        }).catch((error) => {
            vm.loading=false;
            console.log('error: '+error);
        })
    },
    deleteCatalog(catalog){
        let vm = this;
        if(confirm('¿Desea eliminar el catalogo "' + catalog.name + '" definitivamente? Esta acción no puede deshacerse')==true){
            this.$http.get("/api/catalogs/delete/" + catalog.id)
            .then(() => {
                
                vm.getCatalogs();
            }).catch((error) => {
                console.log('error: '+error);
            })
        }
    },
    copyUrl(url) {
        alert('URL copiada al portapapeles');
        const el = document.createElement('textarea');
        el.value = url;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
        document.body.removeChild(el);
    },
    getPDF(id){
        this.$http.get(process.env.VUE_APP_BASE_URL+"/api/catalogs/exportPDF/" + id)
        .then(() => {
        });        
    },
    prevPage(){
        if(this.filters.page>1){
            this.page = this.page-1;
            this.getCatalogs();
        }
    },
    nextPage(){
        if (this.filters.page<this.totalPages){
            this.page = this.page +1;
            this.getCatalogs();
        }
    },
    changePage(data){
        this.page = data;
        this.getCatalogs();
    },
    inIntervalPage(index){
        if(this.totalPages<=this.pageInterval){return true;}

        let limitprev = this.filters.page - (this.pageInterval/2);
        let limitnext = this.filters.page + (this.pageInterval/2);

        if(limitprev<0){
            limitprev=0;
            limitnext=this.pageInterval;
        }

        if(index>limitprev && index<limitnext){
            return true;
        }

        return false;
    },
  },
  computed: {
    editCatalogLink() {
        return { name: 'Editar catalogo'}
    }
  },
  watch: {
      'filters.q': {handler: function () {this.getCatalogs();}},
      'filters.itemsPerPage': {handler: function () {this.getCatalogs();}},
  },
}
</script>

<style lang="css">

.textRed{
    font-weight: bold;
    text-align: center;
    color: #e73d4a;
}
.textGreen{
    font-weight: bold;
    text-align: center;
    color: #5CB85C;
}

.modal-sm-mask {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-sm-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-sm-container {
    width: 50vw;
    margin: 0px auto;
    background-color: var(--surface);
    padding: 10px 20px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    height: 150px;
    padding-top: 25px;
    padding-left: 50px;
}

.modal-sm-header {
    display: flex;
    align-items: center;
}

.modal-sm-enter {
    opacity: 0;
}

.modal-sm-leave-active {
    opacity: 0;
}

.footer{
    display: flex;
    justify-content: flex-end;
    gap: 30px;
}

.modal-sm-enter .modal-sm-container,
.modal-sm-leave-active .modal-sm-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>
